import type { ColDef } from 'ag-grid-community';
import { AG_CELL_CLASSES } from 'src/features/ag-grid/cell-classes';
import { isXvtReadOnlyRow } from './column-generator/helpers/AuthorizationHelper';
import { DefaultColDef } from './ForecastGridConstants';

export const XVT_READ_ONLY_TOOLTIP =
  'This scenario contains rows in xVT-owned cost centers (7802/7113). These rows are read-only and can only be changed in the xVT Planning tab.';

export const XVT_READ_ONLY_DEFAULT_COL_DEF: ColDef = {
  ...DefaultColDef,
  cellClassRules: {
    ...DefaultColDef.cellClassRules,
    [AG_CELL_CLASSES.exportReadonly]: (params) => isXvtReadOnlyRow(params.data)
  }
};
